import AppRecord from './AppRecord.js'

class EntityPrice extends AppRecord {
}

export default EntityPrice
